"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueItem = exports.Queue = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var QueueItem = /*#__PURE__*/function () {
  function QueueItem(runnable) {
    _classCallCheck(this, QueueItem);

    this._id = null;
    this._name = null;
    this.runnable = runnable;
    this.onComplete = null;
    this.onError = null;
    this.result = null;
    this.error = null;
    this.locked = false;
    this.wasCancelled = true;
  }

  _createClass(QueueItem, [{
    key: "log",
    value: function log() {
      if (process.env.NODE_ENV === "development") {
        var _console;

        (_console = console).log.apply(_console, [this._id, this.name].concat(Array.prototype.slice.call(arguments)));
      }
    }
  }, {
    key: "name",
    get: function get() {
      if (this._name) {
        return this._name;
      } else if (this.runnable) {
        return this.runnable.prototype.constructor.name;
      } else {
        return "QueueItem";
      }
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.run();

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                _this.error = _context.t0;
                console.log(_context.t0);

              case 9:
                _this.end();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      })));
    }
  }, {
    key: "end",
    value: function end() {
      if (this.error) {
        if (this.onError) {
          this.onError(this, this.error);
        }
      } else {
        if (this.onComplete) {
          this.onComplete(this, this.result);
        }
      }
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.runnable();

              case 3:
                this.result = _context2.sent;
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                this.error = _context2.t0;
                console.error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "cleanUp",
    value: function cleanUp() {}
  }, {
    key: "cancel",
    value: function cancel() {
      this.cleanUp();
      this.onError = null;
      this.onComplete = null;
      this.wasCancelled = true;
    }
  }]);

  return QueueItem;
}();

exports.QueueItem = QueueItem;

var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck(this, Queue);

    this.jobIdCounter = 0;
    this.maxConcurrent = 3;
    this.pending = [];
    this.running = [];
    this._isActive = true;
    this.onItemCompleted = this.onItemCompleted.bind(this);
    this.onItemError = this.onItemError.bind(this);
  }

  _createClass(Queue, [{
    key: "isActive",
    get: function get() {
      return this._isActive;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.pending.length === 0 && this.running.length === 0;
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      if (!this.locked) {
        item._id = this.jobIdCounter++;
        item.onComplete = this.onItemCompleted;
        item.onError = this.onItemError;
        this.pending.push(item); //console.log("Queue: add", item.name)

        if (this._isActive) {
          this.tick();
        }
      } else {
        console.warn("Queue: addItem called while locked", item.name);
      }
    }
  }, {
    key: "add",
    value: function add(runnable) {
      if (!this.locked) {
        var item = new QueueItem(runnable, this.onItemCompleted, this.onItemError);
        this.addItem(item);
      }
    }
  }, {
    key: "remove",
    value: function remove(item) {
      var success = false;
      var index = this.pending.indexOf(item);

      if (index !== -1) {
        this.pending.splice(index, 1);
        success = true;
      } //console.log("Queue: remove", item.name, success)


      return success;
    }
  }, {
    key: "start",
    value: function start() {
      this._isActive = true;
      this.tick();
    }
  }, {
    key: "stop",
    value: function stop() {
      this._isActive = false;
    }
  }, {
    key: "clear",
    value: function clear() {
      // console.log("Queue: clear")
      this.pending = [];

      var _iterator = _createForOfIteratorHelper(this.running),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.cancel();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.running = [];
    }
  }, {
    key: "onItemCompleted",
    value: function onItemCompleted(item) {
      //console.log("Queue: item completed", item.name)
      var index = this.running.indexOf(item);

      if (index !== -1) {
        this.running.splice(index, 1);
      }

      if (this._isActive) {
        this.tick();
      }
    }
  }, {
    key: "onItemError",
    value: function onItemError(item, err) {
      console.error("Queue: item error", item.name, err);
      var index = this.running.indexOf(item);

      if (index !== -1) {
        this.running.splice(index, 1);
      }

      if (this._isActive) {
        this.tick();
      }
    }
  }, {
    key: "tick",
    value: function tick() {
      if (this.isActive && !this.isEmpty) {
        var _iterator2 = _createForOfIteratorHelper(this.pending),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (this.running.length < this.maxConcurrent) {
              this.running.push(item);
              this.pending.splice(this.pending.indexOf(item), 1); //console.log("Queue: start", item.name)

              item.start();
            } else {
              // queue is full
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);

  return Queue;
}();

exports.Queue = Queue;